import React from 'react';

export const PencilEditIcon: React.FC = () => (
	<svg
		width="17"
		height="16"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="edit-icon"
	>
		<g clipPath="url(#clip0_pencil_edit)">
			<path
				d="M10.0191 3.79714L12.8191 6.59714M5.11914 14.2973L1.61914 14.9973L2.31914 11.4973L12.8191 0.997314L15.6191 3.79731L5.11914 14.2973Z"
				stroke="#0E171C"
				strokeLinecap="round"
				strokeLinejoin="round"
			></path>
		</g>
		<defs>
			<clipPath id="clip0_pencil_edit">
				<rect
					width="16"
					height="16"
					fill="white"
					transform="translate(0.619141 -0.00268555)"
				></rect>
			</clipPath>
		</defs>
	</svg>
);
